import { Link, useLocation } from '@tanstack/react-router';
import { X } from 'lucide-react';

import { studentNavGroups } from './studentNav';

import { cn } from '@/lib/cn';

interface MobileNavDrawerProps { open: boolean; onClose: () => void; }

export function MobileNavDrawer({ open, onClose }: MobileNavDrawerProps) {
  const location = useLocation();
  if (!open) return null;
  const isActive = (to: string) => location.pathname === to || location.pathname.startsWith(to + '/');

  return (
    <div className="fixed inset-0 z-40 lg:hidden">
      <div data-testid="drawer-backdrop" className="absolute inset-0 bg-black/40" onClick={onClose} />
      <aside className="absolute left-0 top-0 h-full w-full overflow-y-auto bg-white">
        <div className="flex h-[90px] items-center border-b border-[#f1f1f1] px-6">
          <img
            src="/images/logo.svg"
            alt="KodPrep — Code. Learn. Excel."
            width={126}
            height={54}
            className="h-[54px] w-[126px]"
          />
          <button
            type="button"
            onClick={onClose}
            aria-label="Close menu"
            className="ml-auto flex h-9 w-9 items-center justify-center rounded-[10px] text-[#9ca3af] transition-colors hover:bg-[#f3f4f6] hover:text-[#111827]"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <nav className="flex flex-col gap-1 px-4 py-5">
          {studentNavGroups.flatMap((group) => group.items).map((item) => {
            const active = isActive(item.to);
            return (
              <Link
                key={item.to}
                to={item.to as any}
                onClick={onClose}
                className={cn(
                  'flex items-center gap-3 rounded-[14px] px-[14px] py-[11px] text-[14px] leading-[21px]',
                  active
                    ? 'bg-[#fff4f0] font-semibold text-[#111827]'
                    : 'font-normal text-[#6b7280] hover:bg-[#f9fafb]',
                )}
              >
                <span className={cn('shrink-0', active ? 'text-[#FF5A1F]' : 'text-[#9CA3AF]')}>
                  {item.icon}
                </span>
                {item.label}
              </Link>
            );
          })}
        </nav>
      </aside>
    </div>
  );
}
